/** @format */

export default {
	SET_TRANSACTIONS: 'SET_TRANSACTIONS',
	SET_ERROR_FOR_TRANSACTIONS: 'SET_ERROR_FOR_TRANSACTIONS',
	SET_TRANSACTIONS_SUMMARY: 'SET_TRANSACTIONS_SUMMARY',
	SET_ERROR_FOR_TRANSACTIONS_SUMMARY: 'SET_ERROR_FOR_TRANSACTIONS_SUMMARY',
	SET_FRAUD_OUTCOME_TRANSACTIONS: 'SET_FRAUD_OUTCOME_TRANSACTIONS',
	SET_ERROR_FOR_FRAUD_OUTCOME_TRANSACTIONS:
		'SET_ERROR_FOR_FRAUD_OUTCOME_TRANSACTIONS',
	SET_FRAUD_OUTCOME_TRANSACTIONS_SUMMARY:
		'SET_FRAUD_OUTCOME_TRANSACTIONS_SUMMARY',
	SET_ERROR_FOR_FRAUD_OUTCOME_TRANSACTIONS_SUMMARY:
		'SET_ERROR_FOR_FRAUD_OUTCOME_TRANSACTIONS_SUMMARY',
};
